import { createSelector } from 'reselect';
import { getBranches } from 'redux/modules/branches/selectors';

import { getCustomerSlotBranchId } from './index';

export const getBranchByCustomerSlotBranchId = createSelector(
  [getBranches, getCustomerSlotBranchId],
  (branches, branchId) => branches.find(branch => branch.id === branchId),
);
